import React from 'react'
import LoginForm from '../components/Login/LoginForm'
import NavBar from '../components/Nav/NavBar'


function LoginPage() {
  return (
    <>
    <NavBar display='hide'/>
    <LoginForm/>
    
    </>
  )
}

export default LoginPage